import KH from './kh'
import ID from './id'
import PER from './per'
import ZTO from './zto'

export const SiteSet: any = () => {
  switch (location.hostname) {
    case 'www.loda.co.id':
      return ID
      break
    case 'www.loda.com.kh':
      return KH
      break
    case 'www.loda.com.pe':
      return PER
      break
    default:
      return KH
      break
  }
}
